import { Injectable } from '@angular/core';
import { environment } from 'projects/shared/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class LinksService {
  // ❌ OLD (buggy): URLApp = environment.apiUrl.replace(/api-/, "").replace(/api./, "").replace('v1', '').slice(0, -1) +'en/';
  // ✅ NEW: Remove hardcoded 'en/' — it will be added dynamically when needed
  private _baseUrl: string;
  
  constructor() {
    // Extract base URL without locale
    const raw = environment.apiUrl
      .replace(/api-/, "")
      .replace(/api\./, "")
      .replace('v1', '')
      .replace(/\/+$/, ''); // Remove trailing slashes
    
    // Remove any existing locale suffix (/en or /ar)
    this._baseUrl = raw.replace(/\/(en|ar)$/i, '');
  }

  /**
   * Base URL without locale (e.g., 'https://card4games.com')
   * Use UrlUtility.buildUrl() to construct full URLs with locale + path
   */
  get baseUrl(): string {
    return this._baseUrl;
  }

  /**
   * @deprecated Use baseUrl + UrlUtility.buildUrl() instead
   * Kept for backward compatibility — returns base + 'en/'
   */
  get URLApp(): string {
    return `${this._baseUrl}/en/`;
  }

  facebook = 'https://www.facebook.com/Card4GamesLTD';
  instgram = 'https://www.instagram.com/card4games/';
}

